import { motion } from "framer-motion";
import { Award, Globe2, TrendingUp } from "lucide-react";

const REGIONS = ["United Kingdom", "United States", "Ireland", "Germany", "Africa", "India", "UAE"];

const ACHIEVEMENTS = [
  { icon: TrendingUp, text: "120+ automation systems shipped, saving clients an estimated 60,000+ manual hours every year" },
  { icon: Globe2, text: "Trusted by clients across the UK, US, Ireland, Germany, Africa, India and the UAE" },
  { icon: Award, text: "Average 3.2x return on investment within the first year of deployment" },
];

export const Founder = () => {
  return (
    <section id="about" className="relative py-28 lg:py-36 px-6" data-testid="founder-section">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9 }}
        className="max-w-3xl mx-auto text-center"
      >
        <p className="text-xs tracking-[0.3em] uppercase text-[#00F2FE] mb-5">Chapter 04 — Our story</p>
        <h2 className="font-['Outfit'] font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#E8F1F5] leading-tight">
          Built on <span className="gradient-text font-medium">18 years</span> beneath the surface of tech
        </h2>
        <p className="font-['Outfit'] font-medium text-lg text-[#E8F1F5] mt-6" data-testid="founder-name">
          Abhilash Krishnankutty Pushpa — Founder & CEO
        </p>

        <p className="mt-8 text-base leading-relaxed text-[#E8F1F5]/85 border-l-2 border-[#00F2FE]/50 pl-6 italic text-left">
          "I help businesses work smarter with AI, intelligent automation, and custom digital
          systems. I design and build AI-powered workflows that reduce repetitive tasks, improve
          efficiency, automate customer interactions, and help businesses scale."
        </p>
        <p className="mt-5 text-base leading-relaxed text-[#8AA1B1] text-left">
          From AI agents and lead automation to CRM workflows, customer support, and business
          process automation — Abhilash turns time-consuming manual work into streamlined
          systems that work around the clock. Nearly two decades in tech, spanning London,
          Berlin, New York, Dublin, Dubai and Mumbai, shape everything we build: practical,
          battle-tested AI automation that survives contact with the real world.
        </p>

        <div className="mt-10 space-y-5 text-left">
          {ACHIEVEMENTS.map((a, i) => (
            <div key={i} data-testid={`founder-achievement-${i}`} className="flex items-start gap-4">
              <span className="w-9 h-9 shrink-0 rounded-full border border-[#00F2FE]/30 bg-[#00F2FE]/10 flex items-center justify-center">
                <a.icon className="w-4 h-4 text-[#00F2FE]" />
              </span>
              <p className="text-sm leading-relaxed text-[#E8F1F5]/85 pt-1.5">{a.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-9 flex flex-wrap justify-center gap-2.5" data-testid="founder-skills">
          {["AI Strategy", "Automation", "AI Agents", "Business Systems", "Workflow Integration"].map((s) => (
            <span
              key={s}
              className="rounded-full px-4 py-1.5 text-xs border border-[#00F2FE]/35 bg-[#00F2FE]/5 text-[#00F2FE] hover:bg-[#00F2FE]/15 transition-colors duration-300"
            >
              {s}
            </span>
          ))}
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-2.5" data-testid="founder-regions">
          {REGIONS.map((r) => (
            <span
              key={r}
              className="rounded-full px-4 py-1.5 text-xs border border-[#10E59A]/30 bg-[#10E59A]/5 text-[#10E59A] hover:bg-[#10E59A]/15 transition-colors duration-300"
            >
              {r}
            </span>
          ))}
        </div>
      </motion.div>
    </section>
  );
};
